var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('vue-headful',{attrs:{"title":_vm.getPageTitle(`Accepting Invitation`)}}),(_vm.isLoading)?_c('b-loading',{attrs:{"is-full-page":"","active":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }